/**
 * Documentation Content Index
 * 
 * All training documentation content is organized in separate modules
 * for better maintainability. Import what you need from here.
 */

import { indexDoc } from './index.js';
import { customerDoc } from './customer.js';
import { orderDoc } from './order.js';
import { purchaseOrderDoc } from './purchaseOrder.js';
import { paymentsDoc } from './payments.js';
import { settingsDoc } from './settings.js';
import { productCatalogDoc } from './productCatalog.js';
import { techStackDoc } from './techStack.js';

// Re-export individual docs
export { indexDoc, customerDoc, orderDoc, purchaseOrderDoc, paymentsDoc, settingsDoc, productCatalogDoc, techStackDoc };

// Combined DOCS object for DocsViewer compatibility
export const DOCS = {
  'index': indexDoc,
  'customer': customerDoc,
  'order': orderDoc,
  'purchase-order': purchaseOrderDoc,
  'product-catalog': productCatalogDoc,
  'payments': paymentsDoc,
  'settings': settingsDoc,
  'tech-stack': techStackDoc,
};

// Document list for navigation
export const docsList = [
  { id: 'index', title: 'Overview' },
  { id: 'customer', title: 'Customer Module' },
  { id: 'order', title: 'Order Module' },
  { id: 'purchase-order', title: 'Purchase Orders' },
  { id: 'product-catalog', title: 'Product Catalog (Detailed)' },
  { id: 'payments', title: 'Payments' },
  { id: 'settings', title: 'Admin Settings' },
  { id: 'tech-stack', title: 'Tech Stack' },
];

export default DOCS;
